"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChannelAttributesCode = exports.SalesChannelConnectionStatus = exports.SalesChannelType = void 0;
var SalesChannelType;
(function (SalesChannelType) {
    SalesChannelType["DIRECT"] = "direct";
    SalesChannelType["INDIRECT"] = "indirect";
})(SalesChannelType = exports.SalesChannelType || (exports.SalesChannelType = {}));
var SalesChannelConnectionStatus;
(function (SalesChannelConnectionStatus) {
    SalesChannelConnectionStatus["CONNECTED"] = "connected";
    SalesChannelConnectionStatus["DISCONNECTED"] = "disconnected";
    SalesChannelConnectionStatus["INVALID"] = "invalid";
    SalesChannelConnectionStatus["AVAILABLE"] = "available";
})(SalesChannelConnectionStatus = exports.SalesChannelConnectionStatus || (exports.SalesChannelConnectionStatus = {}));
var ChannelAttributesCode;
(function (ChannelAttributesCode) {
    ChannelAttributesCode["AMAZON_SETTINGS"] = "AMAZON_SETTINGS_CODE";
    ChannelAttributesCode["BC_CHANNEL"] = "BC_CHANNEL";
    ChannelAttributesCode["ORDER_INGESTION"] = "ORDER_INGESTION";
    ChannelAttributesCode["SAFETY_STOCK"] = "SAFETY_STOCK";
    ChannelAttributesCode["SHOPIFY_SETTINGS"] = "SHOPIFY_SETTINGS";
    ChannelAttributesCode["WOOCOMMERCE_DELIVERY"] = "WOOCOMMERCE_DELIVERY";
})(ChannelAttributesCode = exports.ChannelAttributesCode || (exports.ChannelAttributesCode = {}));
//# sourceMappingURL=SellerSalesChannels.js.map